import { Link } from "@tanstack/react-router";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-warm-bg-base flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-warm-text-primary mb-4">404</h1>
        <p className="text-warm-text-secondary text-lg mb-6">
          Page not found
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-warm-blue text-white rounded-lg hover:opacity-90 transition-opacity"
        >
          Go home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
